<template>
    <a-table :dataSource="datasource" :columns="column" :pagination="pageData" @change="tableChangeHandle">
        <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'flag'">
                <div v-if="record.pgaFlags?.length > 0">
                    <a-tag v-for="tag in record.pgaFlags"
                    :key="tag"
                    :color="getColor(tag)"
                    >
                    {{ tag }}
                    </a-tag>
                </div>
            </template>
        </template>
    </a-table>
</template>
<script lang="ts">
import { defineComponent, nextTick, onMounted, onUnmounted, reactive, ref,defineExpose } from 'vue'
import Api from '@/api/Api'
import { getPgaColor } from "@/common/tool"
import { message } from 'ant-design-vue';

export default defineComponent({
    name : 'PGALibs',
    components:{

    },
    
    setup(props, {emit}) {
        const datasource : any  = ref([])
        const column  = [
            {title: "HTS Code", key : "HtsCode", dataIndex : "originHtsCode"},
            {title: "HTS  Description", key : "description", dataIndex : "originDescription"},
            {title: "PGA Flag", key: "flag", dataIndex : "pgaFlags"},
            {title: "Create Time", key: "createTime", dataIndex : "createTime"},
        ]
        const pageData = reactive({
            current : 1,
            pageSize : 10,
            total : 0,
            showSizeChanger : false,
            showQuickJumper : false,
            showLessItems : false,
        })
        let search_str = ref("")

        onMounted(() =>{
            nextTick(()=>{
                getData()
            })
        })

        onUnmounted(()=>{
            console.log("unmounted")
            search_str.value = ""
        })

        const getData = async() =>{
            let params : any = {
                pageSize : pageData.pageSize,
                pageNum : pageData.current,
            }
            if( search_str.value !=""){
                params.originHtsCode = search_str.value
            }
            emit("load_event", true)
            datasource.value = []
            let data = await Api.getPgaLibs(params)
            emit("load_event", false)
            console.log(data)
            if( data && data?.code === 200){
                pageData.total = data.total
                datasource.value = data.rows
            }else{
                message.error("Get Data Fail",2)
            }
            
        }

        const tableChangeHandle = (pagination : any) =>{
            if( pageData.current === pagination.current && pageData.pageSize === pagination.pageSize){
                return
            }else{
                pageData.total = 0
                pageData.current = pagination.current
                pageData.pageSize = pagination.pageSize
                getData()
            }
        }

        const getColor = (key : string ) =>{
            return getPgaColor(key)
        }

        const search = async(key : string) =>{
            search_str.value = key
            //console.log("call child func")
            pageData.current = 1
            getData()
        }

        return {
            datasource,
            column,
            pageData,
            tableChangeHandle,
            getColor,
            search
        }
    },
})
</script>